<style>

</style>

<Header 
back = "{true}"
on:search="{ () => push('/search-results') }">Search</Header>
<div class="has-header"></div>

<SearchInput></SearchInput>

<SearchResults></SearchResults>

<ActionBar></ActionBar>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import SearchInput from "../components/SearchInput.svelte";
import SearchResults from "../components/SearchResults.svelte";

</script>